import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(30, 30, 30, .7), rgba(30, 30, 30, 1)',
    barImage: require('./assets/sidebar.jpg'),
    logoImage: require('./assets/logo.png'),
    drawer: null,
    userInfo: [],
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_USERINFO (state, payload) {
      state.userInfo = payload
    },
  },
  actions: {

  },
})
